import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { PATH } from '@app/constants';
import { IsAuthGuard, IsNotAuthGuard } from '@app/guards';

import { AuthenticationLoginComponent } from './authentication-login/authentication-login.component';
import { AuthenticationRegisterDevComponent } from './authentication-register-dev/authentication-register-dev.component';
import { AuthenticationRegisterComponent } from './authentication-register/authentication-register.component';
import { AuthenticationComponent } from './authentication.component';


const routes: Routes = [
  {
    path: '', component: AuthenticationComponent, children: [
      { canActivate: [IsNotAuthGuard], path: PATH.LOGIN, component: AuthenticationLoginComponent },
      { canActivate: [IsNotAuthGuard], path: PATH.REGISTER, component: AuthenticationRegisterComponent },
      { canActivate: [IsAuthGuard], path: PATH.REGISTRY_DEVELOPER, component: AuthenticationRegisterDevComponent },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthenticationRoutingModule { }
